import {LobbyImage} from '@colonist/types'
import {type TranslationObject} from '@colonist/i18n'
import {type UIMMatchmakingController} from './UIMMatchmakingController.ts'
import {UIMMatchmakingSearchingView} from './UIMMatchmakingSearchingView.ts'
import {MatchmakingMatchTypes} from '@colonist/game-base-types'

export class UIMMatchmakingSearchingRush4PView extends UIMMatchmakingSearchingView<MatchmakingMatchTypes.RankedRush4P> {
    constructor(matchmakingController: UIMMatchmakingController) {
        const loadingText: TranslationObject = {key: 'strings:homePage.matchmakingPopup.searchingForOpponents'}
        const title: TranslationObject = {key: 'strings:homePage.matchmakingPopup.rankedRush.title'}
        const imageSrc = LobbyImage.GameModeColonistRush

        super(matchmakingController, title, imageSrc, loadingText, MatchmakingMatchTypes.RankedRush4P)
    }

    addTitle() {
        super.addTitle()
        this.setTimeElapsedCounter()
    }
}
